import React from 'react';
import type { Zone } from '../types/zone';

interface ZoneFilterProps {
  selectedZone: Zone | null;
  onZoneChange: (zone: Zone | null) => void;
}

export default function ZoneFilter({ selectedZone, onZoneChange }: ZoneFilterProps) {
  // Generate all possible zones (1A-13B)
  const zones: Zone[] = [];
  for (let num = 1; num <= 13; num++) {
    zones.push(`${num}A` as Zone);
    zones.push(`${num}B` as Zone);
  }

  return (
    <div className="mb-6">
      <label htmlFor="zone" className="block text-sm font-medium text-gray-700 mb-2">
        Filter by Growing Zone
      </label>
      <select
        id="zone"
        value={selectedZone || ''}
        onChange={(e) => onZoneChange(e.target.value as Zone || null)}
        className="w-full max-w-xs rounded-md border-gray-300 shadow-sm focus:border-green-500 focus:ring-green-500"
      >
        <option value="">All Zones</option>
        {zones.map((zone) => (
          <option key={zone} value={zone}>
            Zone {zone}
          </option>
        ))}
      </select>
    </div>
  );
}